import React, { useState } from "react";

const ActiveModal = ({ itemName, onClose, onActive }) => {
  const [loading, setLoading] = useState(false);

  const handleActive = async () => {
    setLoading(true);
    await onActive();
    setLoading(false);
  };

  return (
    <div className="fixed inset-0 bg-black/60 z-50 flex items-center justify-center p-4">
      <div className="bg-white rounded-xl w-full max-w-md p-6 shadow-lg">
        <div className="text-center">
          <svg
            className="mx-auto h-12 w-12 text-green-600"
            fill="none"
            stroke="currentColor"
            viewBox="0 0 24 24"
          >
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth="2"
              d="M5 13l4 4L19 7"
            />
          </svg>

          <h3 className="mt-3 text-lg font-semibold text-gray-900">
            {itemName}
          </h3>

          <p className="mt-2 text-sm text-gray-500">
            Are you sure you want to Active/Inactive this {itemName}? Once done, it can be editable.
          </p>

          <div className="mt-5 flex justify-center gap-3">
            <button
              type="button"
              onClick={onClose}
              disabled={loading}
              className="px-4 py-2 text-sm font-medium text-gray-700 bg-gray-100 rounded-md hover:bg-gray-200"
            >
              Cancel
            </button>

            <button
              type="button"
              onClick={handleActive}
              disabled={loading}
              className="px-4 py-2 text-sm font-medium text-white bg-green-600 rounded-md hover:bg-green-700"
            >
              {loading ? "Submiting..." : "Submit"}
            </button>
          </div>

        </div>
      </div>
    </div>
  );
};

export default ActiveModal;